/* global window, navigator */
import { MOENGAGE_USER_PROPERTIES } from 'Constants/tracking';
// import { getGeolocationPosition } from 'Actions/categoryBrowsing';

// IDENTIFY USER IN MOENGAGE
const identifyUserInMoengage = userProperties => {
    if (window.Moengage && window.Moengage.identifyUser && typeof window.Moengage.identifyUser === 'function') {
        window.Moengage.identifyUser(userProperties);
    }
};

// DESTROY SESSION ON LOGOUT
const destroyMESession = () => {
    if (window.Moengage && window.Moengage.destroy_session && typeof window.Moengage.destroy_session === 'function') {
        window.Moengage.destroy_session();
    }
};

const getBadgeStatus = (user, badgeType) => {
    let badge;

    if (user && user.badges) {
        badge = user.badges.find(({ type }) => type === badgeType);
    }

    return badge && badge.status;
};

const getDefaultMEProperties = (sessionLongByCookie, countryName, countryIsoCode, lang, deviceFP) => {
    const defaultProperties = {
        [MOENGAGE_USER_PROPERTIES.OLX_COUNTRY]: countryName,
        [MOENGAGE_USER_PROPERTIES.OLX_COUNTRY_CODE]: countryIsoCode?.toLowerCase(),
        [MOENGAGE_USER_PROPERTIES.LANG]: lang,
        [MOENGAGE_USER_PROPERTIES.DFP]: deviceFP
    };

    if (typeof navigator !== 'undefined') {
        Object.assign(defaultProperties, {
            [MOENGAGE_USER_PROPERTIES.DEVICE_LANG]: navigator.language
        });
    }
    if (sessionLongByCookie) {
        Object.assign(defaultProperties, {
            [MOENGAGE_USER_PROPERTIES.SESSION_LONG]: sessionLongByCookie
        });
    }

    return defaultProperties;
};

const getMEUserIdentity = userID => {
    return {
        [MOENGAGE_USER_PROPERTIES.IDENTITY]: userID
    };
};

const getMEPropertiesFromUserObj = user => {
    const fbLogin = getBadgeStatus(user, 'facebook');
    const gPlusLogin = getBadgeStatus(user, 'gplus');
    const appleLogin = getBadgeStatus(user, 'apple');

    const properties = {
        [MOENGAGE_USER_PROPERTIES.OLX_USER_ID]: user.id,
        [MOENGAGE_USER_PROPERTIES.NAME]: user.name,
        [MOENGAGE_USER_PROPERTIES.GPLUS_LOGIN]: gPlusLogin,
        [MOENGAGE_USER_PROPERTIES.FB_LOGIN]: fbLogin,
        [MOENGAGE_USER_PROPERTIES.APPLE_LOGIN]: appleLogin,
        [MOENGAGE_USER_PROPERTIES.PROFILE_PHOTO]: user.images && !!user.images.length,
        [MOENGAGE_USER_PROPERTIES.REG_DATE]: user.created_at,
        [MOENGAGE_USER_PROPERTIES.IS_BUSINESS]: user.is_business,
        [MOENGAGE_USER_PROPERTIES.PHONE]: user.phone,
        [MOENGAGE_USER_PROPERTIES.LAST_LOGIN_DATE]: user.last_login_at,
        [MOENGAGE_USER_PROPERTIES.PHOTO]: (user.images && user.images[0] && user.images[0].url) || ''
    };

    if (user.contacts && user.contacts.isValidEmail && user.contacts.email) {
        Object.assign(properties, {
            [MOENGAGE_USER_PROPERTIES.EMAIL]: user.contacts.email
        });
    }

    Object.keys(properties).forEach(key => (!properties[key] || typeof properties[key] !== 'string') && delete properties[key]);

    return properties;
};

const pushProfile = user => {
    const userProperties = getMEPropertiesFromUserObj(user);

    identifyUserInMoengage(userProperties);
};

const handleUserObject = res => {
    if (res.data && res.data.data) {
        pushProfile(res.data.data);
    }
};

export {
    getBadgeStatus,
    getMEPropertiesFromUserObj,
    getDefaultMEProperties,
    getMEUserIdentity,
    handleUserObject,
    pushProfile,
    identifyUserInMoengage,
    destroyMESession
};
